import { render, staticRenderFns } from "./genral-info.vue?vue&type=template&id=de6e54c2&scoped=true&"
import script from "./genral-info.vue?vue&type=script&lang=js&"
export * from "./genral-info.vue?vue&type=script&lang=js&"
import style0 from "./genral-info.vue?vue&type=style&index=0&id=de6e54c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6e54c2",
  null
  
)

export default component.exports